/**
 * Normalize a user-supplied block tag into the value `eth_call` /
 * `eth_estimateGas` expects: hex-encoded for numbers (`0x121eac0`),
 * passthrough for tag strings (`'latest'`, `'pending'`, `'earliest'`),
 * defaults to `'latest'` when omitted.
 */
export function normalizeBlockTag(tag: number | string | undefined): string {
  if (tag === undefined) {
    return 'latest';
  }
  return typeof tag === 'number' ? `0x${tag.toString(16)}` : tag;
}
